/** @format */

export const PUBLIC_URL = {
  LOGIN: "/login",
};

export const PRIVATE_ROOT = {
  DASHBOARD: "/admin/dashboard",
  SETTING: "/admin/setting",
};
